import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-delete-delegate',
  templateUrl: './modal-delete-delegate.component.html',
  styleUrls: ['./modal-delete-delegate.component.css']
})
export class ModalDeleteDelegateComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalDeleteDelegateComponent> , public dialog: MatDialog) { }

  ngOnInit() {
  }
  Accept(){
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
  }

}
